import React from 'react';
import styles from './ProfileImage.module.scss';
import { Avatar } from '@mui/material';
import { omit } from 'lodash';

export type ProfileImageProps = {
  source?: string;
  className?: string;
  fullName: string;
  full_name?: string;
  name?: string;
  color?: string;
  useCleanText?: boolean;
  onClick?: (event: any) => void;
  size?: 'default' | 'xxsmall' | 'xsmall' | 'small' | 'big';
};

const sizes = {
  default: undefined,
  xxsmall: { width: 16, height: 16, fontSize: 8 },
  xsmall: { width: 24, height: 24, fontSize: 12 },
  small: { width: 32, height: 32, fontSize: 18 },
  big: { width: 48, height: 48, fontSize: 24 },
};

function stringToColor(string: string) {
  if (!string) {
    return '#5f606d';
  }
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function handleStringAvatar(name: string, size: string, bgcolor: string, color = 'white') {
  return {
    sx: {
      bgcolor: bgcolor || stringToColor(name),
      color,
      ...sizes[size],
    },
    children: name
      .split(' ')
      .slice(0, 2)
      .map((group: string) => group[0]?.toUpperCase?.())
      .join(''),
  };
}

export function ProfileImage(props: ProfileImageProps) {
  const { source, fullName, size, useCleanText, onClick, className, color } = props;
  if (!fullName) return null;
  return (
    <Avatar
      className={[className, onClick ? styles.avatar : ''].join(' ')}
      src={source}
      {...omit(props, 'fullName', 'useCleanText')}
      children={useCleanText ? fullName : undefined}
      sx={sizes[size]}
      {...(useCleanText ? {} : handleStringAvatar(fullName, size, color))}
    />
  );
}
